import { Button, Form, InputNumber, Space, Typography } from 'antd'
import { GeckoMeasurementJson, GeckoMeasurementUnit } from 'types'

import { scopeInUnit } from './scopeMeasurement'
import { ScopeType } from './techniqueTypes'

export const ScopeEstimateField = ({
  id,
  scopeType,
  unit,
  unitLabel,
  estimate,
  sourceEstimate,
  disabled,
  required,
  onChange,
}: {
  id: string
  scopeType: ScopeType
  unit: GeckoMeasurementUnit
  unitLabel: string
  estimate: GeckoMeasurementJson | undefined
  sourceEstimate: GeckoMeasurementJson | undefined
  disabled: boolean
  required: boolean
  onChange: (estimate: GeckoMeasurementJson | undefined) => void
}) => {
  const value = scopeInUnit(estimate, scopeType, unit)
  const sourceValue = scopeInUnit(sourceEstimate, scopeType, unit)
  return (
    <Form.Item
      label={`Estimated scope (${unitLabel})`}
      htmlFor={`${id}-estimate`}
      required={required}>
      <Space wrap>
        <InputNumber
          id={`${id}-estimate`}
          min={0}
          precision={scopeType === 'count' ? 0 : undefined}
          value={value}
          disabled={disabled}
          onChange={(num) =>
            onChange(num === null ? undefined : { num, unit: unit.id })
          }
        />
        {sourceValue !== undefined && (
          <Button disabled={disabled} onClick={() => onChange(sourceEstimate)}>
            Use source requirement
          </Button>
        )}
        {estimate && value === undefined && (
          <Typography.Text type='danger'>
            Saved units do not match this method’s scope.
          </Typography.Text>
        )}
      </Space>
    </Form.Item>
  )
}
